import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { AppComponent } from './app.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { EnvConfig, LanguageService } from '@doc/core';
import { environment } from '../environments/environment';
import { ApiInterceptorModule } from '@doc/api/interceptor'
import { PdfViewerModule } from 'ng2-pdf-viewer';
//import { AngularFileUploaderModule } from "angular-file-uploader";
import { NgxSpinnerModule } from "ngx-spinner";
import { ModalModule } from 'ngx-bootstrap/modal';
import { PermissionGuard, PermissionService, authGuard } from '@doc/api/server-bo';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { MsalModule, MsalService } from '@azure/msal-angular';
import { GlobalToastComponent } from "../../../../libs/feature/document/src/lib/shared/global-toast/global-toast.component";
import { ToastsComponent } from "../../../../libs/feature/document/src/lib/shared/toasts/toasts.component";
// import { ComponentUimoduleModule } from '@doc/component/uimodule';

export function HttpLoaderFactory(httpClient: HttpClient): any {
  return new TranslateHttpLoader(httpClient, '/assets/i18n/', '.json');
}

const msalConfig = {
  auth: {
    clientId: '4937c2fc-3d79-412a-9d7e-d449f788d6b1',
    authority: 'https://login.microsoftonline.com/b7c4ca7a-a4ba-454e-aaf5-c7edf7f73eaa',
    redirectUri: 'https://dev-aidrawinganalysis.km.qa',
    navigateToLoginRequestUrl: false,
  }
};

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('@doc/feature/auth').then(
      (module) => module.FeatureAuthModule
    ),
  },
  {
    path: 'main',
    canActivate: [authGuard],
    loadChildren: () =>
      import('@doc/feature/backoffice').then(
        (module) => module.FeatureBackofficeModule
      ),
  },
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
];

const routeOptions: ExtraOptions = {
  // initialNavigation: 'enabled',
  onSameUrlNavigation: 'reload',
  scrollPositionRestoration: 'top',
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    ModalModule.forRoot(),
    HttpClientModule,
    ApiInterceptorModule,
    RouterModule.forRoot(routes, routeOptions),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    MsalModule.forRoot(new PublicClientApplication(msalConfig), {
      interactionType: InteractionType.Popup,
      authRequest: { scopes: ['User.Read'] },
    }, {
      interactionType: InteractionType.Popup,
      protectedResourceMap: new Map([
        ['https://graph.microsoft.com/v1.0/me', ['User.Read']]
      ])
    }),
    GlobalToastComponent,
    ToastsComponent,
  ],
  providers: [LanguageService, MessageService, PermissionService, PermissionGuard,
    { provide: EnvConfig, useValue: environment },
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }

